<script>
import Swal from "sweetalert2";
export default {
    name: "ImportPreplanning",
    data() {
        return {
            tableData: [],
            filter: "",
            loading: false,
            budgetCopy: 0,
        };
    },
    computed: {
        selectedApi(){
            return this.tableData.filter((item) => item.checkResource);
        },
        totalAmountSelected(){
            return this.selectedApi.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.total);
            }, 0);
        }
    },
    methods: {
        getData(budget) {
            this.budgetCopy = budget;
            this.loading = true;
            this.$store
                .dispatch("preplanningapiresource/GetAllPrePlanningApiResources", this.$store.state.data.cycle)
                .then((res) => {
                    res.data.forEach((item) => {
                        item.checkResource = false;
                        item.totalQty = item.prePlanningApiResourceDetails.reduce((pv, cv) => {
                            return parseFloat(pv) + parseFloat(cv.quantity);
                        }, 0);
                    });
                    this.tableData = res.data;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.showToast(
                        "Something went wrong - getting preplanning",
                        "error"
                    );
                });
        },
        dropData(){
            if(this.budgetCopy < this.totalAmountSelected){
                return this.showToast("Budget is not enough", "error");
            }
            Swal.fire({
                text: "Are you sure you want to import selected resources?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#9b2ddb",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, import it!",
            }).then((result) => {
                if (result.value) {
                    this.$emit("dropData", this.selectedApi);
                }
            });
        }
    }
};
</script>
<template>
    <b-modal
        id="preplanning-modal"
        title="Import API Resource List"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Item Name</th>
                            <th style="width: 120px" class="text-center">
                                Qty
                            </th>
                            <th style="width: 120px" class="text-center">
                                Unit Cost
                            </th>
                            <th style="width: 120px" class="text-center">
                                Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="tableData.length == 0 && !loading">
                            <td colspan="4" class="text-center"><i>No data found</i></td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="4">
                                <div
                                    class="d-flex justify-content-center align-items-center"
                                >
                                    <div class="preloader-component me-2">
                                        <div class="status">
                                            <div class="spinner-chase w-20px h-20px">
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <strong>Loading...</strong>
                                </div>
                            </td>
                        </tr>
                        <template v-if="tableData.length > 0">
                            <tr v-for="x in tableData" :key="x.id">
                                <td>
                                    <div
                                        class="
                                            form-check
                                            form-checkbox-outline
                                            form-check-success
                                            mb-0
                                        "
                                    >
                                        <input
                                            type="checkbox"
                                            :id="`resource-${x.id}`"
                                            class="form-check-input"
                                            v-model="x.checkResource"
                                        /><label
                                            :for="`resource-${x.id}`"
                                            class="form-check-label"
                                        >
                                            <h5 class="text-dark mb-0">
                                                {{ x.itemName }}
                                            </h5>
                                            <small>{{ x.itemCategory.name }}</small>
                                        </label>
                                    </div>
                                </td>
                                <td class="align-middle text-center">{{ x.totalQty }}</td>
                                <td class="align-middle text-center">{{ formatCurrency(x.unitCost) }}</td>
                                <td class="align-middle text-center">{{ formatCurrency(x.total) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center"  v-if="selectedApi.length > 0">
            <div class="font-size-15">
                Total Amount Selected: <span class="text-warning">{{ formatCurrency(totalAmountSelected) }}</span>
            </div>
            <button type="button" class="btn btn-purple d-flex align-items-center" @click="dropData"><i class="bx bx-download me-1"></i>Import {{selectedApi.length}} selected</button>
        </div>
    </b-modal>
</template>